// components/Orders/StepLadder.jsx
// ─────────────────────────────────────────────────────────────────────────────
// A row of rungs with a line between them: where something is in its journey.
//
// Drawn once for every ladder on the order screens. OrderStepTracker feeds it
// the four delivery rungs; the ticket order page (views/Ticketing/
// TicketOrderDetails.js) feeds it a ticket's own cycle, which has no delivery
// leg and can end in red (payment failed, refund required, refunded).
//
//   steps: [{ key, label, state, sub }]
//     state  done | active | todo | failed
//     sub    an optional second line under the label (a time, a count)
// ─────────────────────────────────────────────────────────────────────────────

import React from "react";

const Check = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true">
    <path
      d="M2.5 6.2 4.8 8.5 9.5 3.8"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Cross = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true">
    <path d="M3.5 3.5 8.5 8.5M8.5 3.5 3.5 8.5" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" />
  </svg>
);

const StepLadder = ({ steps = [], label = "Progress", style }) => (
  <div className="rod-progress-track" style={style} role="list" aria-label={label}>
    {steps.map((step, index) => {
      const state = step.state || "todo";
      return (
        <div
          key={step.key || index}
          role="listitem"
          aria-current={state === "active" ? "step" : undefined}
          className={["rod-step", state !== "todo" && state].filter(Boolean).join(" ")}
        >
          <div className="rod-step-dot">
            {state === "done" ? <Check /> : state === "failed" ? <Cross /> : index + 1}
          </div>
          <div className="rod-step-label">{step.label}</div>
          {step.sub && <div className="rod-step-sub">{step.sub}</div>}
        </div>
      );
    })}
  </div>
);

export default StepLadder;
